import React, { createContext, useContext, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import axios from 'axios';

import Login    from './pages/Login';
import Layout   from './components/Layout';
import Dashboard from './pages/Dashboard';
import Contacts from './pages/Contacts';
import EmailCompose from './pages/EmailCompose';
import EmailLog from './pages/EmailLog';
import Users    from './pages/Users';
import Settings from './pages/Settings';

export const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

axios.defaults.baseURL = process.env.REACT_APP_API_URL || '';
axios.interceptors.request.use(cfg => {
  const t = localStorage.getItem('cndb_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
axios.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) {
    localStorage.clear();
    window.location.href = '/login';
  }
  return Promise.reject(err);
});

const RANK = { admin: 3, editor: 2, viewer: 1 };

function Guard({ role, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (role && RANK[user.role] < RANK[role]) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cndb_user')); } catch { return null; }
  });

  const login = (token, u) => {
    localStorage.setItem('cndb_token', token);
    localStorage.setItem('cndb_user', JSON.stringify(u));
    setUser(u);
  };
  const logout = () => { localStorage.clear(); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 3500,
          style: { borderRadius: '10px', border: '1px solid #E2E8F0', boxShadow: '0 8px 24px rgba(10,15,30,0.12)', fontSize: '13px' }
        }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Guard><Layout /></Guard>}>
            <Route index element={<Dashboard />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="emails/compose" element={<Guard role="editor"><EmailCompose /></Guard>} />
            <Route path="emails/log" element={<EmailLog />} />
            <Route path="users" element={<Guard role="admin"><Users /></Guard>} />
            <Route path="settings" element={<Guard role="admin"><Settings /></Guard>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}
